<script>
export default {
  name: 'WorkOrderGateSidebar',
  props: {
    gateTitle: {
      type: String,
      required: true,
    },
    progressText: {
      type: String,
      default: '',
    },
    checklistItems: {
      type: Array,
      default: () => [],
    },
    helperText: {
      type: String,
      default: 'The WO stays in this stage until every item is met.',
    },
    actionLabel: {
      type: String,
      default: 'Move to next stage',
    },
    disabled: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    normalizedChecklistItems() {
      return this.checklistItems.map((item) => {
        if (typeof item === 'string') {
          return {
            label: item,
            passed: false,
          }
        }

        return {
          label: item.label,
          passed: Boolean(item.passed),
        }
      })
    },
    metCount() {
      return this.normalizedChecklistItems.filter((item) => item.passed).length
    },
    computedProgressText() {
      if (this.progressText) return this.progressText

      return `${this.metCount} of ${this.normalizedChecklistItems.length} met`
    },
    buttonDisabled() {
      return this.disabled || this.loading
    },
  },
}
</script>

<template>
  <aside class="wo-panel wo-gate-panel">
    <div class="wo-gate-panel__header">
      <h2>{{ gateTitle }}</h2>
      <span>{{ computedProgressText }}</span>
    </div>

    <div class="wo-checklist">
      <div
        v-for="item in normalizedChecklistItems"
        :key="item.label"
        class="wo-checklist__item"
        :class="{ 'wo-checklist__item--met': item.passed }"
      >
        <span class="wo-checklist__icon" aria-hidden="true">{{ item.passed ? '✓' : '×' }}</span>
        <div>
          <strong>{{ item.label }}</strong>
        </div>
      </div>
    </div>

    <p class="wo-gate-panel__helper">{{ helperText }}</p>

    <button type="button" class="wo-start-button" :disabled="buttonDisabled" @click="$emit('move-next')">
      {{ loading ? 'Updating status...' : actionLabel }}
    </button>
  </aside>
</template>
